<!-- User account details -->
<div class="MainContainerGeneral">
    <div class="row " id="firstRow">
        <div class="col-md-6" id="leftCol">
            <p class="subHeading">Account Details</p>
        </div>

        <div class="col-md-6" id="rightCol">

            <div *ngIf=" submitted && !loading">
                <p *ngIf="isSuccess" class="alert alert-success">{{message}}</p>
                <p *ngIf="!isSuccess" class="alert alert-danger">{{message}}</p>
            </div>
            <form [formGroup]="form" (ngSubmit)="updatePassword()" #data>
                <div class="col inputColTwin">
                    <div class="leftInput">
                        <label class="lblInput" for="firstName">First Name</label>
                        <input type="text" formControlName="first_name" placeholder="Enter first name"
                            class="form-control input" style="height: 52px; font-size: 14px;"
                            [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }" readonly>
                    </div>

                    <div class="rightInput">
                        <label class="lblInput" for="lastName">Last Name</label>
                        <input type="text" formControlName="last_name" placeholder="Enter last name"
                            class="form-control input" style="height: 52px; font-size: 14px;"
                            [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" readonly>
                    </div>
                </div>

                <div class="col inputCol">
                    <div class="input-lg">
                        <label class="lblInput" for="email">Email</label>
                        <input type="email" formControlName="email" placeholder="Enter email address"
                            class="form-control input" aria-describedby="emailHelp"
                            style="height: 52px; font-size: 14px;"
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" readonly>
                    </div>
                </div>

                <div class="col inputCol">
                    <div class="input-lg">
                        <label class="lblInput" for="firstName">Password</label>
                        <input type="password" formControlName="password" class="form-control inputPassword"
                            style="height: 52px; font-size: 14px;" placeholder="Enter new password">
                    </div>
                </div>

                <div class="col inputCol">
                    <div (click)="updatePassword()"
                        style="color:#fff; display: flex; justify-content: center; align-items: center; width: 180px; height: 42px; background-color: #2D5697;
                     border: 2px solid #2D5697; border-radius: 5px; font-weight: 400; font-size: 14px !important; cursor: pointer;">
                        <!-- <input type="submit" class="txt-changePw regBtn" value="Change Password"> -->
                        Change Password
                    </div>

                </div>
            </form>
        </div>
    </div>
    <!-- Location Details -->
    <div *ngIf="loggedUserRole === 4 && outlet.length > 0" class="row pt-5" id="secondRow">
        <div class="col-md-6" id="leftCol">
            <p class="subHeading">Location Details</p>
        </div>
        <form [formGroup]="formTwo" #data>
            <div class="col inputColTwin">
                <div class="leftInput">
                    <label class="lblInput" for="outletName">Outlet Name</label>
                    <input type="text" formControlName="outlet_name" placeholder="Outlet Name"
                        class="form-control input" style="height: 52px; font-size: 14px;" readonly>
                </div>

                <div class="rightInput">
                    <label class="lblInput" for="outletCode">Code</label>
                    <input type="text" formControlName="outlet_code" placeholder="Outlet Code"
                        class="form-control input" style="height: 52px; font-size: 14px;" readonly>
                </div>
            </div>
        </form>
    </div>

    <!-- Deliveroo Credentials -->
    <div *ngIf="loggedUserRole === 1 " class=" pt-5">
        <div class="col-md-6 removeMargin"  >
            <p class="textHeader">Deliveroo Details</p>
        </div>

        <div *ngIf=" dpSubmitted && !dpLoading">
            <p *ngIf="isDpSuccess" class="alert alert-success">{{dpMessage}}</p>
            <p *ngIf="!isDpSuccess" class="alert alert-danger">{{dpMessage}}</p>
        </div>
        <div class="row" id="secondRow">
            <div class="col-md-6 " id="leftCol">
                <p class="subHeading">Deliveroo Credentials</p>
            </div>
            <div class="">
                <form [formGroup]="dpCredentialForm" #data>
                    <div class="col inputColTwin">
                        <div class="leftInput">
                            <label class="lblInput" for="outletName">Username</label>
                            <input type="text" formControlName="username" placeholder="Username"
                                class="form-control input" style="height: 52px; font-size: 14px;">
                        </div>

                        <div class="rightInput">
                            <label class="lblInput" for="outletCode">Password</label>
                            <input type="password" formControlName="password" placeholder="Password"
                                class="form-control input" style="height: 52px; font-size: 14px;">
                        </div>
                    </div>
                </form>
                <div class="col inputCol">
                    <div (click)="saveCredentials()"
                        style="color:#fff; display: flex; justify-content: center; align-items: center; width: 180px; height: 42px; background-color: #2D5697;
             border: 2px solid #2D5697; border-radius: 5px; font-weight: 400; font-size: 14px !important; cursor: pointer;">
                        Save Changes
                    </div>

                </div>
            </div>
        </div>
        <div class="row" id="secondRow" style="margin-top: 10px">
            <div class="col-md-6 " id="leftCol"> 
                <p class="subHeading">Deliveroo Version</p>
            </div>
            <div class=""> 
                <form [formGroup]="deliveroVersionForm" #data>
                    <div class="col inputColTwin">
                        <div class="form-group input-lg mb-0">
                            <label class="lblInput">Selected version</label>
                            <div class="form-group">
                                <select class="custom-select" style=" font-size: 14px; height: 42px;" id="inlineFormCustomSelect3"
                                    formControlName="deliveroo_version" 
                                    [ngClass]="{ 'is-invalid': submittedVersion && dvf.deliveroo_version.errors}" >  
                                    <option value='' selected>Choose...</option>
                                    <option *ngFor="let version of versionTypes; let i = index" [ngValue]="version.versionCode">
                                        {{version.versionCode}}</option>
                                </select> 
                            </div>
                                <div class="invalid-feedback d-block" *ngIf="submittedVersion && dvf.deliveroo_version.errors?.required">
                                    <div>Version is required!</div>
                                </div>
                        </div> 
                    </div> 
                </form>
                <div class="col inputCol">
                    <div (click)="updateDeliverooVersion()"
                        style="color:#fff; display: flex; justify-content: center; align-items: center; width: 180px; height: 42px; background-color: #2D5697;
                     border: 2px solid #2D5697; border-radius: 5px; font-weight: 400; font-size: 14px !important; cursor: pointer;">
                        <div class="" *ngIf="!loaderVersion">Save Changes</div>
                        <div *ngIf="loaderVersion" style="position: absolute;">
                            <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff" type="ball-clip-rotate"
                                [fullScreen]="false"></ngx-spinner>
                        </div>
                    </div>
        
                </div>
            </div>
        </div>
    </div>

    <!-- Common Brand Details -->
    <div *ngIf="loggedUserRole === 1 " class=" pt-5">
        <div *ngIf=" submittedBrand && !brandLoading">
            <p *ngIf="brandMessage != ''" class="alert alert-success">{{brandMessage}}</p>
        </div>
        <div class="row" id="secondRow">
            <div class="col-md-6 " id="leftCol">
                <p class="textHeader">Common Brand Details</p>
            </div>

            <div class="">
                <form [formGroup]="commonBrandForm" #data>
                    <div class="col inputCol">
                        <div class="input-lg">
                            <label class="lblInput" for="text">Common Brand Name</label>
                            <input type="text" formControlName="common_brand_name" placeholder="Enter Brand Name"
                                class="form-control input" aria-describedby="emailHelp"
                                style="height: 52px; font-size: 14px;"
                                [ngClass]="{ 'is-invalid': submittedBrand && brandF.common_brand_name.errors }">
                        </div>
                    </div>
                    <div class="col inputCol">
                        <div class="input-lg">
                            <label class="lblInput" for="text">Common Brand Logo</label>
                            <div class="col">
                                <div class="row mt-3">
                                    <div class="profileImage">
                                        <img class="brandLogo"
                                            [src]=" logoURL == '' && commonBrandForm.controls['common_logo'].value == null ? '../../../../assets/images/user.png' : logoURL != '' ? logoURL : commonBrandForm.controls['common_logo'].value"
                                            alt="">
                                        <p class="textStyle">{{logoHeader}}</p>
                                    </div>
                                    <div class="custom-file fileInputDiv">
                                        <input type="file" class="custom-file-input fileInput" id="customFile"
                                            name="myfile" (change)="setBrandLogo($event)" #UploadFileInput
                                            accept="image/png, image/jpeg"
                                            [ngClass]="{ 'is-invalid': submittedBrand && brandF.common_logo.errors || logoFileError}">
                                        <span class="fileInputLabel">Click here to upload image(png/jpeg) file</span>
                                        <div *ngIf="submittedBrand && brandF.common_logo.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="brandF.common_logo.errors?.required">Please select an
                                                image(png) file</div>
                                        </div>
                                        <div *ngIf="logoFileError" class="invalid-feedback">
                                            <div>Please select an file(png)</div>
                                        </div>
                                    </div>

                                    <div style="font-size: 14px;  margin-top: 25px;">
                                        <div class="form-group-toggle">
                                            <label for="exampleInputEmail1" class="mr-2">Has Google Reservation </label>
                                            <ui-switch size="small" switchColor="white" color="#00c10b"
                                                defaultBgColor="white" uncheckedLabel="Off" checkedLabel="On"
                                                checkedTextColor="white" defaultBoColor="#cccccc"
                                                (valueChange)="updateSwitch($event)" [(ngModel)]="hasGoogleReservation"
                                                [ngModelOptions]="{standalone: true}">
                                            </ui-switch>
                                        </div>

                                    </div>

                                    <div class="col inputCol">
                                        <div class="input-lg">
                                            <label class="lblInput" for="email">Google Reservation Username</label>
                                            <input type="text" formControlName="google_reservation_username"
                                                placeholder="Enter Google Reservation Username"
                                                class="form-control input" aria-describedby="emailHelp"
                                                style="height: 52px; font-size: 14px;"
                                                [ngClass]="{ 'is-invalid': submittedBrand && brandF.google_reservation_username.errors }">
                                            <div *ngIf="submittedBrand && brandF.google_reservation_username.errors"
                                                class="invalid-feedback">
                                                <div *ngIf="brandF.google_reservation_username.errors.required">Google
                                                    reservation username is required if you enable google reservation
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="col inputCol ">
                    <div (click)="saveBrandDetails()"
                        style="color:#fff; display: flex; justify-content: center; align-items: center; width: 180px; height: 42px; background-color: #2D5697;
         border: 2px solid #2D5697; border-radius: 5px; font-weight: 400; font-size: 14px !important; cursor: pointer;">
                        Save Changes
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>